<template>
    <TableField
        v-model:params="params"
        :data="contacts"
        :columns="columns"
        :loading="loading"
        showCreate
        showSearch
        stickyHeader
        columnChooser
        mobileDevices
        section="contacts"
        @fetch-data="populateData"
        @action="handleAction"
        @onCreate="create"
    />

    <MessageBox ref="destroyMsgBox" @confirm="sendMessageDestroy($event, 1)" />
    <ModalContact ref="showModalContact" @onStore="onStoreContact" />
    <message :message="message" :link="isMsg" :isVisible=isVisibleMsg @onVisible="changeIsVisibleMsg" />
</template>

<script src="./Contacts.js"></script>
